import Vue from 'vue'
import ElementUI from 'element-ui';
// import { ColorPicker } from 'element-ui'
import App from './App.vue'
import './assets/sass/main.scss'
Vue.use(ElementUI);

// Vue.component(ColorPicker.name, ColorPicker)

const app = new Vue({
    el: '#app',
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js